<template>
  <nav class="navbar sticky-top navbar-dark bg-primary shadow">
    <div class="container-fluid d-flex">
      <slot name="before"></slot>
      <slot name="title" class="flex-fill">
        <router-link to="/" class="navbar-brand">c3s</router-link>
      </slot>
      <slot></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar"
};
</script>

<style lang="scss" scoped>
// nav {
//   // opacity: 0.9;
//   background-color: rgba(14, 111, 253, 0.8) !important;
//   -webkit-backdrop-filter: blur(10px);
//   backdrop-filter: blur(10px);
// }
</style>
